import AboutUs from './about-us';
import './App.css';
import ContactUs from './contact-us.js';
import Home from './Home.js';
import Services from './servicesPage.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ShippingPolicy from './ShippingPolicy.js';
import TermsAndConditions from './TermsAndConditions.js';
import CancellationAndRefundPolicy from './CancellationAndRefundPolicy.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import Career from './Components/Career.js';
import ServicePageTemplate from './Components/ServicePageTemplate.js';
import InternshipPage from './InternshipPage.js';
import VerificationPage from './VerificationPage.js';
import AmbassadorPage from './AmbassadorPage.js';
import NotFound from './Components/NotFound.js';
// import ProgramPage from './ProgramPage.js'; // TEMPORARILY HIDDEN

import FloatingWhatsApp from './Components/FloatingWhatsApp.js';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Handle the static splash screen present in index.html
    const splashScreen = document.getElementById('static-splash-screen');
    if (!splashScreen) return;

    // Check if we are running during react-snap build (we want to keep the splash screen for the static HTML)
    const isReactSnap = navigator.userAgent === 'ReactSnap';

    if (!sessionStorage.getItem('splashShown') && !isReactSnap) {
      // First time loading in the browser - let the animation run, then fade it out
      const fadeTimer = setTimeout(() => {
        splashScreen.classList.add('fade-out');
      }, 1200);

      const removeTimer = setTimeout(() => {
        splashScreen.remove();
        sessionStorage.setItem('splashShown', 'true');
      }, 1700);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    } else if (!isReactSnap) {
      // Already shown in this session - remove immediately
      splashScreen.remove();
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cancellation-and-refund-policy" element={<CancellationAndRefundPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/services/:serviceId" element={<ServicePageTemplate />} />
        <Route path="/internship" element={<InternshipPage />} />
        {/* <Route path="/programs/ai-powered-full-stack-developer" element={<ProgramPage />} /> */} {/* TEMPORARILY HIDDEN */}
        <Route path="/verify" element={<VerificationPage />} />
        <Route path="/ambassador" element={<AmbassadorPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <FloatingWhatsApp />
    </BrowserRouter>
  );
}

export default App;